// import PhoneGrab from './phone_grab.png'
import PhoneGrab from './Phone.png'

export const images = [
  { title: 'service_example', alt: '서비스 구동 사진', src: PhoneGrab },
]
